/**
 * Escapes RegExp as string
 *
 * @collboard-modules-sdk
 */
export function escapeRegExp(regExp: string): string {
    // TODO: Probbably use replaceAll instead of replace
    return regExp.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
